import type { CellContext } from "@tanstack/react-table";

import type { ApiColumn } from "@/types/api";

export const defaultCell = <TData, TValue>(column: ApiColumn<TData>) => ({
  header: column.internalName,
  accessorKey: column.fieldName,
  cell: (info: CellContext<TData, TValue>) => info.getValue() || "—",
});
